<template>
   <v-card>    
    <v-card-text
      v-if="items.length"
      class="app-card-content"
    >
      <v-timeline dense>
        <v-slide-x-reverse-transition
          group
          hide-on-leave
        >
          <v-timeline-item
            v-for="item in items"
            :key="item.id"
            small
            fill-dot
            :color="colorizeItem(item)"
          >
            <v-avatar
              slot="icon"
              :color="colorizeItemAvatar(item)"
              :size="15"
            >
              <v-icon
                :size="17"
                color="white"
              >
                {{ buildAvatarIcon(item) }}
              </v-icon>
            </v-avatar>

            <v-alert
              :value="true"
              border="left"
              :color="colorizeItemAlert(item)"
              dark
              class="white--text"
            >
              <p class="acompanhamento-text">
                <strong>Ação: </strong>
                <span>{{ item.action.label }}</span>
              </p>
              <p                
                class="acompanhamento-text"
              >
                <strong>Status: </strong>
                <span>{{ item.status.label }}</span>
              </p>              
              <p
                v-if="item.reason"
                class="acompanhamento-text"
              >
                <strong>Motivo Rejeição: </strong>
                <span>{{ item.reason }}</span>
              </p>
              <p
                v-if="item.entity_type === 'DOCUMENT'"
                class="acompanhamento-text"
              >
                <strong>Tipo Arquivo: </strong>
                <span>{{ item.document_type.label }}</span>
              </p>
              <p
                v-if="item.file_name"
                class="acompanhamento-text"
              >
                <strong>Nome Arquivo: </strong>
                <span>{{ item.file_name }}</span>
              </p>           
              <p class="acompanhamento-text">
                <strong>Criado em: </strong>
                <span>{{ item.created_at.formatted }}</span>
              </p>
            </v-alert>
          </v-timeline-item>
        </v-slide-x-reverse-transition>
      </v-timeline>
    </v-card-text>
    <section
      v-if="isLoading"
      class="isLoading"
    >
      <v-progress-circular
        indeterminate
        color="success"
      />
    </section>
  </v-card>
</template>

<script>
  import AccompanimentService from '@/services/acompanhamento.service';
  
  export default {
    name: 'OrderDetailTabTrakings',
  
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      items: [],

      isLoading: false,
    }),

    mounted() {
      this.fetch();
    },

    methods: {
      fetch() {
        AccompanimentService.list(this.buildParams()).subscribe({
          next: ({items}) => {            
            this.items = items;
          },
          error: (error) => {
            console.error('Error fetching acompanhamentos:', error);
          },
        });
      },

      buildParams() {
        return {
          input: {
            solicitation_id: this.order.id
          },
          inputPage: {
            page: 1,
            per_page: 100, // TODO: criar paginação de acordo com scroll
            sort: 'id:desc'
          }         
        }
      },

      colorizeItem(item) {
        if (item.entity_type === 'SOLICITATION') {
          return 'blue-grey darken-1';
        } else if (item.entity_type === 'PAYMENT') {
          return 'green darken-1';
        } else {
          return 'blue darken-2';
        }
      },

      colorizeItemAvatar(item) {
        if (item.entity_type === 'SOLICITATION') {
          return 'blue-grey darken-1';
        } else if (item.entity_type === 'PAYMENT') {
          return 'green darken-1';
        } else {
          return 'blue darken-2';
        }
      },

      buildAvatarIcon(item) {
        if (item.entity_type === 'SOLICITATION') {
          return 'schedule';
        } else if (item.entity_type === 'PAYMENT') {
          return 'attach_money';
        } else {
          return 'description';
        }
      },

      colorizeItemAlert(item) {
        if (item.entity_type === 'SOLICITATION') {
          return 'blue-grey darken-1';
        } else if (item.entity_type === 'PAYMENT') {
          return 'green darken-1';
        } else {
          return 'blue darken-2';
        }
      }
    }
  };
</script>